import React, { createContext, useState, useContext } from "react";

// Create Context
const ImageContext = createContext();

// Custom Hook
export const useImageContext = () => useContext(ImageContext);

// Context Provider
export const ImageProvider = ({ children }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <ImageContext.Provider value={{ selectedImage, setSelectedImage }}>
      {children}
    </ImageContext.Provider>
  );
};
